module.exports = __webpack_public_path__ + "static/media/wheel-balancing-red.82a57418.svg";